import { Table } from "@/features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type M2Issuer, useM2IssuerColumns } from "./columns";
import { type FilterM2IssuersSchema, FilterM2Issuers } from "./filter";

export const M2IssuersTable = () => {
  const columns = useM2IssuerColumns();
  return (
    <Table<M2Issuer, FilterM2IssuersSchema>
      label="Issuers"
      client={Clients.M2}
      table_name={Tables.M2_ISSUERS}
      columns={columns}
      filter={<FilterM2Issuers />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.M2}/${Tables.M2_ISSUERS}/new`,
        },
      ]}
    />
  );
};
